export const DEALER_ID_TESTING = new Set([
  'DEU00100',
  'DEU00100V',
  'DEU00100N',
  'DEUVW111N',
  'DEU06780V',
  'DEU51004V',
  'ITA00100V',
  'ITA00100N',
  'ITA51004V',
  'ITA264V',
  'ITA264N',
  'SWE00100V',
  'SWE00100N',
]);
